/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Insights_Point_LearningInputs */

const en_why_listening_insights_point_learning = /** @type {(inputs: Why_Listening_Insights_Point_LearningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spindle density rises after learning`)
};

const es_why_listening_insights_point_learning = /** @type {(inputs: Why_Listening_Insights_Point_LearningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La densidad de husos aumenta tras aprender`)
};

/**
* | output |
* | --- |
* | "Spindle density rises after learning" |
*
* @param {Why_Listening_Insights_Point_LearningInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_insights_point_learning = /** @type {((inputs?: Why_Listening_Insights_Point_LearningInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Insights_Point_LearningInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_insights_point_learning(inputs)
	return en_why_listening_insights_point_learning(inputs)
});